var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConversation = function SvgConversation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16003_2744)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.75342 1.53271C3.86339 1.53271 1.50516 3.90956 1.53297 6.80471L1.53271 11.9741L1.61925 11.895C2.35091 11.1633 3.47073 10.9705 4.39578 11.4341C5.09596 11.785 5.88821 11.9745 6.73013 11.9741C9.60386 11.9754 11.9463 9.67831 11.9739 6.80471C12.0017 3.90956 9.69008 1.53271 6.75342 1.53271Z",
    stroke: "#171717",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3472 7.03838C15.6441 8.0012 16.4835 9.56374 16.4668 11.2979L16.4671 16.4673L16.3806 16.3882C15.6489 15.6565 14.5291 15.4637 13.604 15.9273C12.9038 16.2782 12.1116 16.4677 11.2697 16.4673C9.54501 16.4681 8.02626 15.6617 7.06982 14.379",
    stroke: "#171717",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0125 6.78516C10.0125 7.22202 9.65833 7.57617 9.22144 7.57617C8.78454 7.57617 8.43042 7.22202 8.43042 6.78516C8.43042 6.34829 8.78454 5.99414 9.22144 5.99414C9.65833 5.99414 10.0125 6.34829 10.0125 6.78516Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.51294 6.78516C7.51294 7.22202 7.15882 7.57617 6.72192 7.57617C6.28503 7.57617 5.93091 7.22202 5.93091 6.78516C5.93091 6.34829 6.28503 5.99414 6.72192 5.99414C7.15882 5.99414 7.51294 6.34829 7.51294 6.78516Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.01318 6.78516C5.01318 7.22202 4.65906 7.57617 4.22217 7.57617C3.78527 7.57617 3.43115 7.22202 3.43115 6.78516C3.43115 6.34829 3.78527 5.99414 4.22217 5.99414C4.65906 5.99414 5.01318 6.34829 5.01318 6.78516Z",
    fill: "#171717"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16003_2744"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
};
export default SvgConversation;